var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cloud-computing",
    xmlns: "http://www.w3.org/2000/svg",
    width: 142.159,
    height: 111.603,
    viewBox: "0 0 142.159 111.603",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2145",
    "data-name": "Group 2145",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2144",
    "data-name": "Group 2144"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10466",
    "data-name": "Path 10466",
    d: "M118.444,92.009a48.862,48.862,0,0,0-96.125,8.351,26.652,26.652,0,0,0,4.442,52.948h22.21v-8.884H26.761a17.768,17.768,0,0,1,0-35.536,4.442,4.442,0,0,0,4.442-4.442,39.978,39.978,0,0,1,79.2-7.773,4.442,4.442,0,0,0,3.776,3.554,22.21,22.21,0,0,1-3.021,44.2H93.391v8.884h17.768a31.094,31.094,0,0,0,7.285-61.3Z",
    transform: "translate(0 -55.032)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10467",
    "data-name": "Path 10467",
    d: "M198.8,250.3l-17.768,17.768,6.263,6.263,10.217-10.172v42.6H206.4v-42.6l10.172,10.172,6.263-6.263L205.066,250.3A4.442,4.442,0,0,0,198.8,250.3Z",
    transform: "translate(-130.775 -195.158)",
    fill: "#ececec"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.99c20f6509fd30101483440781c9ee42.svg";
export { ForwardRef as ReactComponent };